import Helpers from '..';

/**
 * Checks if desktop side ad should be injected in case no other ad has.
 * @param {Number} bodyIndex Current body index in array.
 * @param {Array} bodyElements Array of elements.
 * @param {Number} currentRuleInjectedComponentCount Number of ads injected in the array.
 * @returns {Boolean}
 */
const shouldInjectFirstSideAd = ({ bodyIndex, currentRuleInjectedComponentCount, bodyElements }) => {
  let shouldInject = false;
  if (Helpers.isLastIndexOfArray({ bodyIndex, bodyElements })) {
    if (currentRuleInjectedComponentCount === 0) { shouldInject = true; }
  }

  return shouldInject;
};

export default shouldInjectFirstSideAd;
